import React from 'react';
import PropTypes from 'prop-types';
import ChatContent from '../../Chat/ChatContent';

/**
 * Layout component of a chat widget
 * @param {object} main
 * @param {string} activeId
 * @param {string} activeDashboardId
 * @param {string} widgetId
 */
const Chats = props => {
  const { main, activeId, activeDashboardId, widgetId } = props;

  return (
    <ChatContent
      key={activeId}
      currentChatId={activeId}
      data={main}
      items={main && main['items'] && main['items']}
      attendees={main && main.attendees && main.attendees}
      activeDashboardId={activeDashboardId}
      widgetId={widgetId}
    />
  );
};

Chats.propTypes = {
  /** The main data */
  main: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  /** Current active ID */
  activeId: PropTypes.string,
  /** Dashboard ID */
  activeDashboardId: PropTypes.string,
  /** Current widgetId */
  widgetId: PropTypes.string,
};

Chats.defaultProps = {
  main: null,
  activeId: '',
  activeDashboardId: '',
  widgetId: null,
};

export default Chats;
